import { Button, Typography } from '@mui/material';

const NotFoundPage = () => {
  return (
    <div>
      <Typography my={5}>Page not found</Typography>

      <Button
        variant="outlined"
        onClick={() => (window.location.href = 'https://trade.options.ai')}
      >
        Return to dashboard
      </Button>
    </div>
  );
};

export default NotFoundPage;
